export const powensUserErrorStates = [
  "SCARequired",
  "webauthRequired",
  "additionalInformationNeeded",
  "wrongpass",
  "decoupled",
  "actionNeeded",
  "passwordExpired",
];
